import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=734db116&scoped=true&"
import script from "./AppCard.vue?vue&type=script&lang=ts&"
export * from "./AppCard.vue?vue&type=script&lang=ts&"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=734db116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734db116",
  null
  
)

export default component.exports